import { render } from "./TrainerList.vue?vue&type=template&id=600aa9cf&ts=true"
import script from "./TrainerList.vue?vue&type=script&lang=ts"
export * from "./TrainerList.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__